import { LibraryContent } from "./LibraryContent";
import { type IPaginationResponse } from "~/interfaces/IPaginationResponse";
import { type IHttpResponse } from "~/interfaces/IHttpResponse";

// セレクション詳細

export class Library implements IHttpResponse, IPaginationResponse {
  constructor(
    public statusCode: number,
    public message: {},
    public path: string,
    public fieldErrors: [],
    public validationMessageList: [],
    public maxCount: number, // 最大件数
    public page: number, // 取得したページ番号
    public pageSize: number, // 1ページ内の表示件数
    public totalPages: number, // 総ページ数

    public libraryId: string,
    public libraryTitle: string,
    public librarySummary: string,
    public isUnread: boolean,
    public isComplete: boolean,
    public contents: LibraryContent[],
    public directory: LibraryContent[], // ディレクトリ
  ) {}
}

export const emptyLibrary = () => new Library(0, {}, "", [], [], 0, 0, 0, 0, "", "", "", false, false, [], []);
